"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconForm = exports.Icon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var StyledIcon = _styledComponents.default.i.withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "ezpruz-0"
})(["", " ", " ", " ", " ", " ", " ", ""], _styledSystem.space, _styledSystem.typography, _styledSystem.flexbox, _styledSystem.layout, _styledSystem.position, (0, _styledSystem.system)({
  color: {
    properties: ['fill'],
    scale: 'colors'
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    micro: {
      fontSize: [0, 0, 0],
      lineHeight: [1, 1, 0]
    },
    tiny: {
      fontSize: [1, 1, 1],
      lineHeight: [3, 3, 2]
    },
    default: {
      fontSize: [2, 2, 2],
      lineHeight: [5, 5, 4]
    },
    small: {
      fontSize: [4, 3, 4],
      lineHeight: [5, 6, 6]
    },
    medium: {
      fontSize: [5, 5, 6],
      lineHeight: [8, 6, 7]
    },
    large: {
      fontSize: [8, 7, 9],
      lineHeight: [10, 9, 13]
    },
    huge: {
      fontSize: [10, 9, 12],
      lineHeight: [12, 11, 16]
    },
    gigantic: {
      fontSize: [11, 13, 15],
      lineHeight: [14, 15, 18]
    }
  }
}));

var Icon = function Icon(props) {
  var children = props.children,
      rest = (0, _objectWithoutProperties2.default)(props, ["children"]);
  return _react.default.createElement(StyledIcon, (0, _extends2.default)({
    p: 0,
    color: "currentColor"
  }, rest), _react.default.Children.only(children));
};

exports.Icon = Icon;
Icon.defaultProps = {
  color: 'currentColor',
  size: 'default'
};

var StyledIconForm = _styledComponents.default.i.withConfig({
  displayName: "Icon__StyledIconForm",
  componentId: "ezpruz-1"
})(["", " ", " ", " ", " ", " ", " ", ""], _styledSystem.space, _styledSystem.flexbox, _styledSystem.layout, _styledSystem.position, (0, _styledSystem.system)({
  color: {
    properties: ['fill'],
    scale: 'colors'
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    none: {},
    micro: {
      fontSize: [0, 0, 0],
      lineHeight: [1, 1, 0]
    },
    tiny: {
      fontSize: [1, 1, 1],
      lineHeight: [1, 1, 1]
    },
    default: {
      fontSize: [2, 2, 2],
      lineHeight: [5, 5, 5]
    },
    small: {
      fontSize: [4, 3, 4],
      lineHeight: [5, 5, 5]
    },
    medium: {
      fontSize: [5, 5, 6],
      lineHeight: [8, 6, 7]
    },
    large: {
      fontSize: [8, 7, 9],
      lineHeight: [10, 9, 13]
    },
    huge: {
      fontSize: [10, 9, 12],
      lineHeight: [12, 11, 16]
    },
    gigantic: {
      fontSize: [11, 13, 15],
      lineHeight: [14, 15, 18]
    }
  }
}), _styledSystem.typography);

var IconForm = function IconForm(props) {
  var children = props.children,
      rest = (0, _objectWithoutProperties2.default)(props, ["children"]);
  return _react.default.createElement(StyledIconForm, (0, _extends2.default)({
    p: 0,
    color: "currentColor"
  }, rest), _react.default.Children.only(children));
};

exports.IconForm = IconForm;
IconForm.defaultProps = {
  color: 'currentColor',
  size: 'default'
};